import styled from "@emotion/styled";

export const FormName = styled.span(props => props.theme.candy.typography.header4.css());

export const FileTable = styled.div({
    display: "flex",
    flexWrap: "wrap",
    width: 520,
    marginTop: 16,
});

export const Column1 = styled.div({
    width: 80,
    paddingRight: 8,
});

export const Column2 = styled.div({
    width: 424,

    "~ *": {
        paddingTop: 8,
    },
});

export const Content = styled.div({
    display: "flex",
    flexDirection: "column",
    width: 595,
    gap: 12,
});

export const ErrorContainer = styled.div({
    width: 520,
});

export const ErrorText = styled.div(props => ({
    color: props.theme.candy.semanticColors.danger.color,
}));

export const Container = styled.div({
    minHeight: 100,
});

export const FormFileProperties = styled.div({
    display: "flex",
    flexDirection: "column",
    gap: 8,
});

export const FormFileDemandDesc = styled.div({
    marginTop: 8,
});

export const FufUploadAlertLayout = styled.div({
    display: "flex",
    gap: 6,
    background: "#CDEDFF",
    padding: 8,
    fontSize: 14,
    borderRadius: 4,
});

export const FufUploadAlertText = styled.p({
    margin: 0,
});
